'use client';

import { loremIpsum } from '@/mocks/loremIpsum';
import Image from 'next/image';
import checkmark from 'public/static/icons/checkmark.svg';
import { useToggle } from '../toggle';
import { ChevronBottom } from '../icons';

interface ITourIncludesProps {
  included: {
    description: string;
    includes?: Array<string>;
  };
}

const includement = ['drinks', 'food', 'shelter', 'transport', 'return tickets'];

export const TourIncludes = ({ included }: ITourIncludesProps) => {
  const { toggle: isExpanded, handleToggle: toggleExpand } = useToggle(true);

  return (
    <div className='flex flex-col gap-4'>
      <div className="flex flex-row justify-between items-center pr-6">
        <h2 className="text-2xl">What&apos;s included</h2>
        <ChevronBottom
          className={`cursor-pointer duration-200 ${isExpanded ? 'rotate-0' : '-rotate-180'}`}
          onClick={() => toggleExpand(!isExpanded)}
        />
      </div>
      {isExpanded && 
        <div className="flex flex-col gap-6">
          <p className="font-light">{included?.description || loremIpsum}</p>
          {!!included?.includes?.length && (
            <div className="flex flex-col gap-y-4">
              {included?.includes.map((item) => (
                <p key={item} className="flex align-center justify-start gap-2 font-light h-5">
                  <Image src={checkmark} alt="checkmark" className="inline" width={20} height={20} />
                  {item}
                </p>
              ))}
            </div>
          )}
        </div>
      }
    </div>
  );
};
